import { http, HttpResponse } from 'msw';
import { env } from '@repo/env';
import { apiPaths } from '@repo/api/client';
import { eventClickMock } from './event-click.mock';
var apiUrl = env.VITE_API_URL;
var apiEndpoint = apiPaths.event.click.path;
export var eventClickHandler = [
    http.post("".concat(apiUrl).concat(apiEndpoint), function () {
        return new HttpResponse(eventClickMock.success, { status: 200 });
    }),
];
// Scenario handlers for use in tests via server.use(...)
export var eventClickErrorHandlers = {
    badRequest: http.post("".concat(apiUrl).concat(apiEndpoint), function () {
        return HttpResponse.json(eventClickMock.errorBadRequest, { status: 400 });
    }),
    internalError: http.post("".concat(apiUrl).concat(apiEndpoint), function () {
        return HttpResponse.json(eventClickMock.errorInternalError, { status: 500 });
    }),
};
